import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import NavSectionButton from 'components/NavSection/NavSectionButton';
import { useLocation } from 'react-router-dom';

interface Props {
  packageId: string;
}

const PackageNavSection = observer(({ packageId }: Props) => {
  const location = useLocation();
  const currentPath = `${location.pathname}${location.search}`;
  const { t } = useTranslation('packages');

  return (
    <>
      <NavSectionButton
        icon="icon_single-content-02_16"
        label={t('subMenu.overview')}
        routePath={`/package/overview?packageId=${packageId}`}
        currentPath={currentPath}
      />
      <NavSectionButton
        icon="icon_data-table_16"
        label={t('subMenu.baseData')}
        routePath={`/package/detail?packageId=${packageId}`}
        currentPath={currentPath}
      />
      <NavSectionButton
        icon="icon_document_16"
        label={t('subMenu.packingList')}
        routePath={`/package/instruments?packageId=${packageId}`}
        currentPath={currentPath}
      />
      <NavSectionButton
        icon="icon_bulb-62_16"
        label={t('subMenu.knowledge')}
        routePath={`/package/content?packageId=${packageId}`}
        currentPath={currentPath}
      />
      <NavSectionButton
        icon="icon_globe_16"
        label={t('subMenu.globalFunctions')}
        routePath={`/package/functions?packageId=${packageId}`}
        currentPath={currentPath}
      />
      {/* TODO */}
      <NavSectionButton
        icon="icon_pin-3_16"
        label={t('subMenu.locations')}
        routePath={`/package/locations?packageId=${packageId}`}
        currentPath={currentPath}
      />
    </>
  );
});

export default PackageNavSection;
